import { render, staticRenderFns } from "./NotificationLog.vue?vue&type=template&id=73c9bed7"
import script from "./NotificationLog.vue?vue&type=script&lang=js"
export * from "./NotificationLog.vue?vue&type=script&lang=js"
import style0 from "./NotificationLog.vue?vue&type=style&index=0&id=73c9bed7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports